import type { ICompanyOpportunitySpotted } from "app/pages/sales-intelligence/modules/top-companies/types/CompanyOpportunitySpotted";
import type { IRowsDtoWrapper } from "app/pages/sales-intelligence/modules/top-companies/types/rowsDtoWrapper";
import type { ITopCompanyItem } from "app/pages/sales-intelligence/modules/top-companies/types/TopCompany";
import type { AssetsCountDto, ListAssetsDto, ListsDto } from "app/pages/sales-intelligence/pages/home/types/dto";
import type {
    SavedSearchesCountsRequestDto,
    SavedSearchesDto,
} from "app/pages/sales-intelligence/pages/home/types/savedSearchesDto";
import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

import type { HomePageApiService } from "./types";

const HOME_PATH_COMPANIES_PREFIX = "/sales-api/home/companies";

export default function createHomePageAPIService(
    fetchService: Readonly<IFetchService>,
): HomePageApiService {
    const basePath = HOME_PATH_COMPANIES_PREFIX;

    return {
        fetchLists(options?: Readonly<GetRequestOptions>): Promise<ListsDto> {
            return fetchService.get(`${basePath}/lists`, undefined, options);
        },

        fetchListsAssetsCount(dto: ListAssetsDto, options?: Readonly<GetRequestOptions>): Promise<AssetsCountDto> {
            return fetchService.post(`${basePath}/list/count`, dto, options);
        },

        fetchSavedSearches(options?: Readonly<GetRequestOptions>): Promise<SavedSearchesDto> {
            return fetchService.get(`${basePath}/searches`, undefined, options);
        },

        fetchSavedSearchesCounts(
            dto: SavedSearchesCountsRequestDto,
            options?: Readonly<GetRequestOptions>,
        ): Promise<AssetsCountDto> {
            return fetchService.post(`${basePath}/search/count`, dto, options);
        },

        fetchTopCompanies(config?: GetRequestOptions): Promise<IRowsDtoWrapper<readonly ITopCompanyItem[]>> {
            return fetchService.get(`${HOME_PATH_COMPANIES_PREFIX}/top`, undefined, config);
        },

        fetchOpportunitySpotted(
            domains: readonly string[],
            config?: GetRequestOptions,
        ): Promise<IRowsDtoWrapper<readonly ICompanyOpportunitySpotted[]>> {
            return fetchService.get(`${HOME_PATH_COMPANIES_PREFIX}/top/opportunity-spotted`, { domains }, config);
        },
    };
}
